import React, { Component } from 'react';
import {
  TextInput,
  FormGroup,
  Checkbox,
  TextArea,
} from 'carbon-components-react';
import { CarType, DateFormat } from '../../helpers/Constants';
import DateTimePicker from '../../helpers/DateTimePicker';
import AttachmentTable from '../common/AttachmentTable';
import { ComboBox } from '../../helpers/ComboBox'; //RITM0945960

export default class AuditFindingCADetail extends Component {

    //RITM0945960 - Effectiveness Check Modification
    constructor(props) {
        super(props);
        this.state = {
            appCorrectiveActionsSuitable: [
                { id: 'option-1', text: 'Yes' },
                { id: 'option-2', text: 'No' },
    
            ],
        }
    }
    //End
    render() {
        //RITM0945960 - Effectiveness Check Modification
        const selectedItemCombo = {
            isCorrectiveActionsSuitable: (this.state.appCorrectiveActionsSuitable || []).find(
                (el) => el.text == this.props.CAModel.isCorrectiveActionsSuitable
              ),
            };
        //End
        return (
            <>
                <div className="bx--grid--full-width">
                {this.props.showCADefinition === true ? (
                    <>
                    {this.props.car.carType == CarType.NC.Code ? (
                    <div className="bx--col--md-12 bx--col-lg-12">
                        <FormGroup legendText= "Correction (immediate treatment) *" >
                        <TextArea
                            maxLength={5000}
                            id="immediateTreatmentNC"
                            placeholder="Input Correction"
                            value={this.props.CAModel.immediateThreatmentNC || ''}
                            onChange={(el) =>
                                this.props.updateState('immediateThreatmentNC', el.target.value, 'model')
                            } 
                            hideLabel
                            labelText=""
                            light
                            rows={4}
                            cols={200}
                            invalid={this.props.validations.immediateThreatmentNC != null}
                            disabled={this.props.isDisabled} 
                        />
                        {this.props.validations.immediateThreatmentNC}
                        </FormGroup>
                    </div>
                    ) : (
                    ''
                    )}
                    <div className="bx--row">
                        <div className="bx--col--md-12 bx--col-lg-12">
                            <FormGroup legendText="Cause of inefficiency *">
                            <TextArea
                                maxLength={5000}
                                id="causeOfInefficiency"
                                placeholder="Input Cause of inefficiency"
                                value={this.props.CAModel.causeOfInefficiency || ''}
                                onChange={(el) =>
                                    this.props.updateState('causeOfInefficiency', el.target.value, 'model')
                                } 
                                hideLabel
                                labelText=""
                                light
                                rows={4}
                                cols={200}
                                invalid={this.props.validations.causeOfInefficiency != null}
                                disabled={this.props.isDisabled} 
                            />
                            {this.props.validations.causeOfInefficiency}
                            </FormGroup>
                        </div>
                        <div className="bx--col--md-12 bx--col-lg-12">
                            <FormGroup
                            legendText={
                                this.props.car.carType == CarType.NC.Code
                                ? 'Corrective action to be implemented *'
                                : 'Corrective action to be implemented/Recommended Action *'
                            }
                            >
                            <TextArea
                                maxLength={5000}
                                id="caImplemented"
                                placeholder="Input Corrective action"
                                value={this.props.CAModel.caImplemented || ''}
                                onChange={(el) => this.props.updateState('caImplemented', el.target.value, 'model')} 
                                hideLabel
                                labelText=""
                                light
                                rows={4}
                                cols={200}
                                invalid={this.props.validations.caImplemented != null}
                                disabled={this.props.isDisabled} 
                            />
                            {this.props.validations.caImplemented}
                            </FormGroup>
                        </div>
                        <div className="bx--col-md-4 bx--col-lg-6">
                            <FormGroup legendText="Due Date*">
                            <DateTimePicker
                                value={this.props.CAModel.dueDate}
                                onChange={this.props.updateState} 
                                type="date"
                                placeholder={DateFormat}
                                name="dueDate"
                                alt="model"
                                invalid={this.props.validations.dueDate != null || this.props.validations.duedate != null}
                                disabled={this.props.isDisabled}
                                className="open-up"
                            />

                            {this.props.validations.dueDate}
                            {this.props.validations.duedate ? (
                                <div className="srv-validation-message">
                                    The Due Date of the CA must be less than or equal to the Due Date of the Finding
                                </div>
                            ) : null}
                            </FormGroup>
                        </div>
                        <div className="bx--col-md-4 bx--col-lg-6">
                            <FormGroup legendText="Due Date Change Notes">
                            <TextInput
                                id="dueDateChangeNotes"
                                name="dueDateChangeNotes"
                                alt="model"
                                placeholder="Input change notes"
                                value={this.props.CAModel.dueDateChangeNotes  || ''}
                                onChange={(el) => this.props.updateState(el.target.name, el.target.value, el.target.alt)} 
                                type="text"
                                hideLabel
                                labelText=""
                                disabled={this.props.isDisabled}
                            />
                            </FormGroup>
                        </div>
                        {this.props.showCASolution === true ? (
                            <>
                                <div className="bx--col--md-12 bx--col-lg-12">
                                    <FormGroup legendText="Evidence of Corrective Action*">
                                    <TextArea
                                        maxLength={5000}
                                        id="immediateThreatment"
                                        placeholder="Input Evidence of Corrective Action"
                                        value={this.props.CAModel.immediateThreatment|| ''}
                                        onChange={(el) =>  this.props.updateState('immediateThreatment', el.target.value, 'model')}
                                        hideLabel
                                        labelText=""
                                        light
                                        rows={4}
                                        cols={225}
                                        className="disable-text"
                                        invalid={this.props.validationsSolution.immediateThreatment != null}
                                        disabled={this.props.isDisabledCAManagement}
                                    />
                                    {this.props.validations.immediateThreatment}
                                    </FormGroup>
                                </div>
                                <div className="bx--col--md-12 bx--col-lg-12">
                                    <FormGroup legendText="Explain*">
                                    <TextArea
                                        maxLength={5000}
                                        id="explain"
                                        placeholder="Explain"
                                        value={this.props.CAModel.explain || ''}
                                        onChange={(el) => this.props.updateState('explain', el.target.value, 'model')}
                                        hideLabel
                                        labelText=""
                                        light
                                        rows={4}
                                        cols={225}
                                        className="disable-text"
                                        invalid={this.props.validationsSolution.explain != null}
                                        disabled={this.props.isDisabledCAManagement}
                                    />
                                    {this.props.validationsSolution.explain}
                                    </FormGroup>
                                    <AttachmentTable
                                        storagePath="audit"
                                        model={this.props.CAModel}
                                        items={this.props.CAModel.attachment}
                                        apiDownloadUrl={`/audit/${this.props.idAudit}/answer/${this.props.idAnswer}/car/${this.props.idFinding}/ca/${this.props.CAModel.id}/attachment/`}
                                        onUploadFIle={this.props.onUploadFile}
                                        onDeleteFile={this.props.onDeleteFile}
                                        disabled={this.props.isDisabledCAManagement}
                                        /> 
                                </div>
                            </>
                           )
                        :  ('')
                        }
                        {this.props.editEffectiveness && (
                            <>
                            <div className="bx--col-md-4 bx--col-lg-6">
                                <FormGroup legendText="Audit Team has analyzed the Corrective Action and their evidences of closing and has assessed them as adequate">
                                <Checkbox
                                    id="isAdequate"
                                    alt="model"
                                    labelText=""
                                    checked={this.props.CAModel.isAdequate || false}
                                    onChange={(value, id) => this.props.updateState(id, value, 'model')} 
                                />
                                </FormGroup>
                            </div>
                            <div className="bx--col-md-4 bx--col-lg-6">
                                <FormGroup legendText="Evidences are attached">
                                <Checkbox
                                    id="evidencesAttached"
                                    alt="model"
                                    labelText=""
                                    checked={this.props.CAModel.evidencesAttached || false}
                                    onChange={(value, id) => this.props.updateState(id, value, 'model')} 
                                    /*disabled={
                                        this.state.model.emailCompilerAuditReport === this.props.user.email
                                      }*/
                                />
                                </FormGroup>
                            </div>
                            <div className="bx--col--md-12 bx--col-lg-12">
                                <FormGroup legendText="Check of the effectiveness of the CA">
                                <TextArea
                                    maxLength={5000}
                                    id="checkEffectiveness"
                                    placeholder="Check of the effectiveness of the CA"
                                    value={this.props.CAModel.checkEffectiveness || ''}
                                    onChange={(el) =>
                                        this.props.updateState('checkEffectiveness', el.target.value, 'model')
                                    } 
                                    hideLabel
                                    labelText=""
                                    light
                                    rows={4}
                                    cols={200}
                                    invalid={this.props.validationsEffectiveness.checkEffectiveness != null}
                                    /*disabled={
                                        this.state.model.emailCompilerAuditReport === this.props.user.email
                                      }*/
                                />
                                </FormGroup>
                                {this.props.validationsEffectiveness.checkEffectiveness}
                            </div>
                            <div className="bx--col-md-4 bx--col-lg-6">
                                <FormGroup legendText="Date of the effectiveness check">
                                <DateTimePicker
                                    value={this.props.CAModel.dateCheck}
                                    type="date"
                                    placeholder={DateFormat}
                                    name="dateCheck"
                                    alt="model"
                                    onChange={this.props.updateState}
                                    className="open-up"
                                    invalid={this.props.validationsEffectiveness.dateCheck != null}
                                    /*disabled={
                                        this.state.model.emailCompilerAuditReport === this.props.user.email
                                      }*/
                                />
                                </FormGroup>
                                {this.props.validationsEffectiveness.dateCheck}
                            </div>
                            {/* RITM0945960 - Effectiveness Check Modification* */}
                            <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Is the corrective actions suitable for the purpose?*">
                                            <ComboBox
                                                    id="isCorrectiveActionsSuitable"
                                                    placeholder="Select"
                                                    name="isCorrectiveActionsSuitable"
                                                    alt="model"
                                                    initialSelectedItem={selectedItemCombo.isCorrectiveActionsSuitable}
                                                    items={this.state.appCorrectiveActionsSuitable}
                                                    itemToString={item => (item ? item.text : '')}
                                                    onChange={(id, val) =>
                                                        this.props.updateState(id, (val ? val.text : null), 'model')}
                                                    invalid={this.props.validationsEffectiveness.isCorrectiveActionsSuitable != null}                                                 
                                                />                                               
                                            </FormGroup>
                                            {this.props.validationsEffectiveness.isCorrectiveActionsSuitable}
                            </div>
                            {/* End */}
                            </>
                        )}
                    </div>
                </>
                ) : "" }
                </div>
            </>
        )
    }
}